<script setup>
import Input from 'dashboard/components-next/input/Input.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import CompanySortMenu from './components/CompanySortMenu.vue';
import CompanyMoreActions from './components/CompanyMoreActions.vue';

defineProps({
  showSearch: { type: Boolean, default: true },
  searchValue: { type: String, default: '' },
  headerTitle: { type: String, required: true },
  activeSort: { type: String, default: 'last_activity_at' },
  activeOrdering: { type: String, default: '' },
});

const emit = defineEmits(['search', 'update:sort', 'create']);
</script>

<template>
  <header
    class="sticky top-0 z-10 border-b border-n-weak bg-n-surface-1/90 px-3 backdrop-blur-[10px] sm:px-6"
  >
    <!-- custom (redesign Modeloja): rail do header no contrato de largura (1480px),
         casando com o corpo; título 24/600 (handoff §Header). -->
    <div
      class="mx-auto flex min-h-14 w-full max-w-[1480px] flex-col items-stretch justify-between gap-2 py-2 sm:flex-row sm:items-center"
    >
      <span
        class="text-[24px] font-semibold tracking-[-0.015em] truncate text-n-slate-12"
      >
        {{ headerTitle }}
      </span>
      <div
        class="flex w-full min-w-0 items-center gap-2 sm:w-auto sm:flex-shrink-0 sm:gap-4"
      >
        <div
          v-if="showSearch"
          class="flex min-w-0 flex-1 items-center gap-2 sm:w-56"
        >
          <Input
            :model-value="searchValue"
            type="search"
            :placeholder="$t('COMPANIES.SEARCH_PLACEHOLDER')"
            :custom-input-class="[
              'h-8 [&:not(.focus)]:!border-transparent bg-n-alpha-2 ltr:!pl-8 !py-1 rtl:!pr-8',
            ]"
            class="w-full"
            @input="emit('search', $event.target.value)"
          >
            <template #prefix>
              <Icon
                icon="i-lucide-search"
                class="absolute -translate-y-1/2 text-n-slate-11 size-4 top-1/2 ltr:left-2 rtl:right-2"
              />
            </template>
          </Input>
        </div>
        <div class="flex flex-shrink-0 items-center gap-2">
          <CompanySortMenu
            :active-sort="activeSort"
            :active-ordering="activeOrdering"
            @update:sort="emit('update:sort', $event)"
          />
          <CompanyMoreActions @create="emit('create')" />
        </div>
      </div>
    </div>
  </header>
</template>
